import type {AuthMedium, LoggedInUserData} from '@aboutyou/user';
import {
  OptionalUserState,
  UserGenders,
  UserState,
  useOptionalUser,
  useUser,
} from '@aboutyou/user';
import {AuthMethod} from '../types';

/**
 * This hook takes care of writing the initial value of the user data to tadarida once the login is successful
 * To ensure compatibility with legacy we also directly write the values to localStorage for mWeb
 */
export const useOnLoginSuccess = () => {
  const {updateCache: updateUserCache} = useUser();
  const {updateCache: updateOptionalUserCache} = useOptionalUser();

  return ({
    method,
    loginType,
    authData,
  }: {
    method: AuthMethod;
    loginType: AuthMedium;
    authData: {
      customerData: LoggedInUserData;
      apiToken: string;
    };
  }) => {
    let userData: UserState;
    let userOptionalData: OptionalUserState;
    if (method === 'guest-register') {
      userOptionalData = {userData: null};
      userData = {
        guestToken: authData.apiToken,
      };
    } else {
      userOptionalData = {
        userData: {
          ...authData.customerData,
          loginType,
          gender:
            authData.customerData.gender === 'male'
              ? UserGenders.Male
              : UserGenders.Female,
        },
      };
      // Real user / non-guest
      userData = {
        token: authData.apiToken,
      };
    }

    updateUserCache(userData);
    updateOptionalUserCache(userOptionalData);
  };
};
